import cookie from 'js-cookie';
import { getResponseHeaders, getErrorResponse } from './helpers';

const READY_STATE = { 0: 'UNSENT', 1: 'OPENED', 2: 'HEADERS_RECEIVED', 3: 'LOADING', 4: 'DONE' };

export default (options) => {
    const {
        method, baseUrl, url, data, queryString, headers, timeout, withCredentials,
        responseType, xsrf, auth, bearerToken, transform, validateStatus, debug,
        onProgress, onBeforeSend
    } = options;

    const xhr = new XMLHttpRequest();

    xhr.timeout = timeout || 0;
    xhr.withCredentials = withCredentials;
    xhr.responseType = responseType;

    const promise = new Promise((resolve, reject) => {
        xhr.open(method, `${baseUrl || ''}${url}${queryString ? `?${queryString}` : ''}`.replace(/\/\//g, '/'));

        // set request headers, should be called after calling open(), but before calling send().
        if (headers !== null) {
            for (let k in headers) {
                Object.prototype.hasOwnProperty.call(headers, k) && xhr.setRequestHeader(k, headers[k]);
            }
        }

        if (xsrf) {
            let cookieValue = cookie.get(xsrf.cookieName);
            if (cookieValue) xhr.setRequestHeader(xsrf.headerName, cookieValue);
        }

        if (bearerToken) xhr.setRequestHeader('Authorization', `Bearer ${bearerToken}`);
        else {
            if (auth && auth.username && auth.password) {
                let base64 = btoa(unescape(encodeURIComponent(`${auth.username}:${auth.password}`)));
                xhr.setRequestHeader('Authorization', `Basic ${base64}`);
            }
        }

        onBeforeSend && onBeforeSend.call(this, options);

        if (onProgress) xhr.upload.onprogress = onProgress;

        xhr.onload = () => {
            const responseHeaders = getResponseHeaders(xhr);

            if (validateStatus(xhr.status)) {
                if (responseType === 'arraybuffer') {
                    const arrayBuffer = xhr.response;
                    if (arrayBuffer) {
                        resolve({
                            response: new Uint8Array(arrayBuffer),
                            headers: responseHeaders,
                            status: xhr.status,
                            statusText: xhr.statusText,
                            options
                        });
                    }
                }
                else {
                    resolve({
                        response: transform.response(xhr.response),
                        headers: responseHeaders,
                        status: xhr.status,
                        statusText: xhr.statusText,
                        options
                    });
                }
            }
            else {
                reject(getErrorResponse(xhr, responseHeaders));
            }
        };

        // only triggers if the request couldn't be made at all
        xhr.onerror = () => reject(getErrorResponse(xhr));

        xhr.onreadystatechange = function () {
            debug && console.log(READY_STATE[this.readyState]);
        };

        // send the request
        data ? xhr.send(transform.request(data)) : xhr.send();
    });

    promise.xhr = xhr;

    return promise;
}